<template>
  <Details/>
</template>

<script>
import details from './details';

export default {
  components: {
    Details: details,
  },
};
</script>
